import * as React from 'react';

function SvgSkype(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M481.398 271.398c.301-4.796.602-9.597.602-14.398 0-124.2-101.8-227-226-227-4.8 0-9.602.3-14.398.602C215.5 10.8 183.699 0 151 0 68.2 0 0 69.2 0 152c0 32.7 10.8 64.5 30.602 90.598C30.3 247.398 30 252.199 30 257c0 124.2 101.8 225 226 225 4.8 0 9.602-.3 14.398-.602C296.5 501.2 328.301 512 361 512c82.8 0 151-67.2 151-150 0-32.7-10.8-64.5-30.602-90.602zm0 0"
        fill="#25d9f8"
      />
      <path
        d="M512 362c0 82.8-68.2 150-151 150-32.7 0-64.5-10.8-90.602-30.602-4.796.301-9.597.602-14.398.602V30c124.2 0 226 102.8 226 227 0 4.8-.3 9.602-.602 14.398C501.2 297.5 512 329.301 512 362zm0 0"
        fill="#00c0f1"
      />
      <path
        d="M256 227c-24.3 0-60-12-60-30 0-17.7 36-29.7 58.2-29.7h1.8c26.7.298 48.3 10.5 56.102 19.798 12.597 15.601 40.496 13.203 50.097-6.598 10.2-20.7-6.898-38.102-25.8-51-21-13.8-50.7-20.7-80.399-20.7-78.602 0-120 44.4-120 88.2 0 45 45.898 90 120 90 24.3 0 60 12 60 30 0 17.7-36 29.7-58.2 29.7H256c-26.7-.302-48.3-10.5-56.102-19.802C188.801 313.102 160 312.2 149.801 333.5c-10.2 20.7 6.898 38.102 25.8 51C197.5 398.898 226 407 256 407c74.098 0 120-44.7 120-90 0-45-45.902-90-120-90zm0 0"
        fill="#ececf1"
      />
      <g fill="#e2e2e7">
        <path d="M376 317c0 45.3-45.902 90-120 90v-60.3h1.8c22.2 0 58.2-12 58.2-29.7 0-18-35.7-30-60-30v-60c74.098 0 120 45 120 90zm0 0M312.102 187.098C304.3 177.8 282.699 167.598 256 167.3v-58.5c29.7 0 59.398 6.898 80.398 20.699 18.903 12.898 36 30.3 25.801 51-9.601 19.8-37.5 22.2-50.097 6.598zm0 0" />
      </g>
    </svg>
  );
}

export default SvgSkype;
